"use client"

import React from "react"
import { CheckCircleIcon, CircleAlertIcon, XCircleIcon } from "lucide-react"

export default function GlobalMessageBanner({
  message,
  showClose = true,
  refEl,
  onCloseAction,
}: {
  message: { type: "success" | "error"; text: string } | null | undefined
  showClose?: boolean
  refEl?: React.RefObject<HTMLDivElement | null>
  onCloseAction?: () => void
}) {
  if (!message) return null

  return (
    <div
      ref={refEl}
      className={
        "rounded-sm border-t-4 px-3 py-2 shadow-xs " +
        (message.type === "success"
          ? "border-green-600 bg-green-50 text-green-900"
          : "border-red-600 bg-red-50 text-red-900")
      }
      role="status"
    >
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2">
          {message.type === "success" ? (
            <CheckCircleIcon className={"size-5 text-green-600"} />
          ) : (
            <CircleAlertIcon className={"size-5 text-red-600"} />
          )}
          <div className="text-sm font-semibold">{message.text}</div>
        </div>
        {showClose && (
          <button
            type="button"
            aria-label="close"
            className="text-muted-foreground"
            onClick={() => onCloseAction && onCloseAction()}
          >
            <XCircleIcon className={"size-5"} />
          </button>
        )}
      </div>
    </div>
  )
}
